/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkTypeDto } from '../../models/create-work-type-dto';
import { WorkType } from '../../models/work-type';

export interface WorkTypesControllerCreate$Params {
      body: CreateWorkTypeDto
}

export function workTypesControllerCreate(http: HttpClient, rootUrl: string, params: WorkTypesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkType>> {
  const rb = new RequestBuilder(rootUrl, workTypesControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkType>;
    })
  );
}

workTypesControllerCreate.PATH = '/work-types/admin';
